module.exports = __webpack_public_path__ + "img/meet-the-team.5d15ee2c.jpg";